import React from "react";
import generateAttributes from "../../functions/generateAttributes";
import "../../styles/pages/Insights.scss";
import InsightCard from "../components/InsightCard";
import Divider from "../components/Divider.js";
import DotsPattern from "../components/DotsPattern.js";

// Fake data — replace with real articles later
const articles = [
  {
    id: 1,
    title: "From +3°C to below 2°C: proof that climate action works for infra funds",
    date: "2025-10-21",
    imageUrl: "https://carbone4.com/files/ciara_f094adb829.jpeg",
    to: "https://www.carbone4.com/climate-action-infra-funds"
  },
  {
    id: 2,
    title: "Testimonial from Aldo Diaz Sanchez – ESG & Sustainability Infrastructure Manager at Eurazeo",
    date: "2025-09-29",
    imageUrl: "https://carbone4.com/files/american_public_power_association_513d_Br_MJ_5w_unsplash_adb726cb82.jpg",
    to: "https://www.carbone4.com/testimonial-diaz-sancher-eurazeo"
  },
  {
    id: 3,
    title: "Testimonial from Ginette Borduas, Partner and ESG & Sustainability Director at Meridiam",
    date: "2025-10-21",
    imageUrl: "https://carbone4.com/files/Installation_5c49da6a13.jpg",
    to: "https://www.carbone4.com/testimonial-borduas-meridiam"
  },
  {
    id: 4,
    title: "Testimonial from Bérénice Arbona, Head of Infrastructure Private Debt at LBP AM European Private Markets",
    date: "2025-10-21",
    imageUrl: "https://carbone4.com/files/andreas_gucklhorn_7raz_Cd_RU_Gs_unsplash_56ad2e8bfe.jpg",
    to: "https://www.carbone4.com/testimonial-arbona-lbp-am"
  },
  {
    id: 5,
    title: "Testimonial from Céline Bonnenfant, ESG & Impact Manager at Rivage Investment",
    date: "2025-10-21",
    imageUrl: "https://carbone4.com/files/deal_wotan_1440x504_01a398955f.jpg",
    to: "https://www.carbone4.com/testimonial-bonnenfant-rivage-investment"
  },
  {
    id: 6,
    title: "Testimonial from Gwen Colin, Partner and ESG & Research Director at Vauban IP",
    date: "2025-10-21",
    imageUrl: "https://carbone4.com/files/jan_bottinger_27x_FE_Nkt_lc_unsplash_ec7393f97f.jpg",
    to: "https://www.carbone4.com/testimonial-colin-vauban"
  },
  {
    id: 7,
    title: "Testimonial from Zoé Ormières-Selves, ESG Director at Épopée Gestion",
    date: "2025-10-07",
    imageUrl: "https://carbone4.com/files/67da829b11016962af62540e_particuliers_hero_p_1600_ec62025e57.webp",
    to: "https://www.carbone4.com/testimonial-ormieres-selves-epopee"
  },
  {
    id: 8,
    title: "Testimonial from Assia Gaouar, Partner at Demeter",
    date: "2025-10-02",
    imageUrl: "https://carbone4.com/files/1721821220036_0971ce0e27.jpg",
    to: "https://www.carbone4.com/testimonial-gaouar-demeter"
  },
  {
    id: 9,
    title: "CIARA Methodological guide Mitigating climate change",
    date: "2025-10-21",
    imageUrl: "https://carbone4.com/files/modestas_urbonas_vj_9l20fzj0_unsplash_4b00f16964.jpg",
    to: "https://www.carbone4.com/en/guide-ciara-mitigation-climate-change"
  }
];

function Insights(props) {
  const attr = generateAttributes("Insights", props);

  const sortedArticles = [...articles].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <main {...attr()}>
      <h1 data-visually-hidden>Insights</h1>
      <section {...attr("section #hero")}>
        <DotsPattern />
        <section {...attr("sectionMainInformation #hero")}>
          <h2 {...attr("sectionTitle #hero")}>Insights</h2>
        </section>
      </section>

      <Divider variations="nextToGray:true" />

      <section {...attr("section #articles")}>
        <section {...attr("grid")}>
          {sortedArticles.map((a) => (
            <InsightCard
              key={a.id}
              title={a.title}
              date={a.date}
              imageUrl={a.imageUrl}
              to={a.to}
            />
          ))}
        </section>
      </section>
    </main>
  );
}

export default Insights;
